// auth0-config.ts - Auth0 configuration from Pulumi stack
// This file is auto-generated by scripts/sync-config.js
// Do not edit manually - run 'npm run sync-config' to update

export interface Auth0Config {
  domain: string;
  clientId: string;
  audience: string;
  redirectUri: string;
  scope?: string;
}

// Configuration from Pulumi stack outputs (auth0-infra-dev environment)
export const auth0Config: Auth0Config = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || 'dev.auth.swan.so',
  clientId:
    process.env.REACT_APP_AUTH0_CLIENT_ID || 'ml6zUbrYl3tUW8bR8otwHu4uh0kQzKH0',
  audience:
    process.env.REACT_APP_AUTH0_AUDIENCE || 'https://develop.api.swanvision.ai',
  redirectUri: window.location.origin + '/callback',
  scope: 'openid profile email offline_access',
};

// Connection names for passwordless authentication
export const connectionNames = {
  passwordless: 'email',
  oidcPartner: 'oidc-partner-dev',
};

// API Configuration
export const apiConfig = {
  baseUrl: 'https://o619kgbwkh.execute-api.ap-south-1.amazonaws.com/dev',
  endpoints: {
    protected: '/protected',
  },
};

// Environment info
export const environment = 'auth0-infra-dev';
export const generatedAt = '2025-09-01T01:36:32.801Z';
